import gql from "graphql-tag";

export default gql`mutation CancelHolidayPayReversal($reason: String!, $reversalId: Int!) {
    cancelHolidayPayReversal(reason: $reason, reversalId: $reversalId) {
      id
      createdAt
      updatedAt
      responseAt
      sentAt
      holidayWorkerId
      workerId
      holidayPayrollId
      holidayPaymentId
      paymentStatusId
      dcTransferId
      reversedDcTransferId
      dcCustomerNumber
      paymentProviderReferenceCode
      email
      amount
      errorCode
      errorDescription
      notes
    }
  }`;
